import { cookieConfig } from '@/constants'

/**
 * Saves a cookie in users system with a given name, value and expiration
 * @param name
 * @param value
 * @param daysToExpire
 */
function saveCookie (name, value, daysToExpire) {
  let expires

  if (daysToExpire) {
    const date = new Date()
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000))
    expires = ';expires=' + date.toGMTString()
  } else {
    expires = ''
  }
  document.cookie = name + '=' + JSON.stringify(value) + expires + `;domain=${cookieConfig.domain}`
}

/**
 * Gets a cookie with the given name
 * @param name
 * @returns {string|null}
 */
function getCookie (name) {
  const nameEQ = name + '='
  const ca = decodeURIComponent(document.cookie).split(';')
  for (const element of ca) {
    let c = element
    while (c.charAt(0) === ' ') { c = c.substring(1, c.length) }
    if (c.indexOf(nameEQ) === 0) { return JSON.parse(c.substring(nameEQ.length, c.length)) }
  }
  return null
}

export { saveCookie, getCookie }
